// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const textFragmentPrepare = function($fragmentT, wordWrap) {
  // fragment only once!
  if (!$fragmentT.find('.fragment-t').length) {
    let string = ''
    // +? - one or more (non-greedy)
    // $fragmentT.text().trim().match(/\b(\w+)\b/g) // does not includes special chars
    let html = $fragmentT.html().trim()
    html = html.replace(/<br([^>]*)>/gi, ' <br> ')

    if (wordWrap) {
      // single word animation
      html.split(' ').forEach((item, i) => {
        string += (item.match(/^<br/))? item : '<span class="fragment-t">' + item + '</span> '
      });
    } else {
      const arr = html.split('<br>')
      if (arr.length) {
        arr.forEach((item, i) => {
          string += '<span class="fragment-t">' + item.trim() + '</span> <br>'
        });
      } else {
        string = '<span class="fragment-t">' + html + '</span> <br>'
      }
    }


    $fragmentT.html(string)
  }
  return $fragmentT
}

const textFragmentGet = function($fragmentT) {
  return $fragmentT.find('.fragment-t')
}

export const createTitleTimeline = function($title, vertical=false) {
  let from = {opacity: 0, x: 20}
  let to = {opacity: 1, x: 0}
  if (vertical) {
    from = {opacity: 0, y: 20}
    to = {opacity: 1, y: 0}
  }

  // inviewport title transition
  const titleTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: $title,
      start: "top 60%",
      // once: true,
      // toggleActions: 'play none play reverse',
    }
  })

  fontAnimationAdd(titleTimeline, $title, 0)

  const subtitleStaggers = $title.find('.t')
  if (subtitleStaggers.length) {
    titleTimeline.fromTo(subtitleStaggers, from, {stagger: 0.6, duration: 1,  ...to }, '>-=0.4')
  }

  return titleTimeline
}

export const fontAnimationAdd = function(tl, $text, fontAnimationDuration = 1, fontAnimationPosition = '>', yAnimationDelay = 0, yAnimation = true) {
  const $animatedTitle = $text.find('[data-fragment-t]')
  if (!$animatedTitle.length) {
    return
  }
  const animatedTitleEl = $animatedTitle[0]

  let $animatedTitleShadow
  if(!$animatedTitle.parents('.fragment-t-wrapper').length) {
    $animatedTitle.wrap('<div class="fragment-t-wrapper"></div>')
    textFragmentPrepare($animatedTitle)

    if (fontAnimationDuration) {
      $animatedTitle.addClass('font-variation-linr')
      $animatedTitleShadow = $('<div class="font-variation-linr-0 font-variation-shadow ' + $animatedTitle.attr('class') + '">' + $animatedTitle.html() + '</div>')
      gsap.set($animatedTitleShadow, {opacity: 0})
      $animatedTitle.after($animatedTitleShadow)
    }
  } else {
    if (fontAnimationDuration) {
      $animatedTitleShadow = $animatedTitle.siblings('.font-variation-shadow')
    }
  }

  if (fontAnimationDuration) {
    tl.set(animatedTitleEl, {'--text-linr': 0})
    tl.set($animatedTitleShadow, {opacity: 0, webkitFilter:"blur(0px)"})
  }

  if (yAnimation) {
    tl.fromTo(textFragmentGet($animatedTitle), {opacity: 0, y: 30}, { opacity: 1, y: 0, stagger: 0.4, duration: 1, delay: yAnimationDelay })
  }

  if (fontAnimationDuration) {
    // const fontVar = {val: 0}
    // reset --text-linr
    // https://greensock.com/css-variables/
    // gsap.to("html", {"--myColor": "orange", duration: 1, yoyo: true, repeat: 20});
    tl.set($animatedTitleShadow, {opacity: 1, webkitFilter:"blur(0px)"})
    tl.fromTo(animatedTitleEl, {'--text-linr': 0}, {'--text-linr': 100, duration: fontAnimationDuration}, fontAnimationPosition)
    tl.to($animatedTitleShadow, { opacity: 0, webkitFilter:"blur(3px)", duration: fontAnimationDuration / 2 }, '<')
  }
}
